import { WORKSPACE_PADDING } from '@components/v2/constants';
import { Theme } from '@mui/material';
import { RachelDockedLayout } from './rachel.types';

export const RACHEL_PANEL_WIDTH = 308;

export const RACHEL_SCROLLBAR_INSET = 0.5;

const CARD_SHRINK_TOLERANCE = 0.85;

export const getRachelDockedColumnWidth = (theme: Theme, dockedWidth: number) =>
  `calc(${dockedWidth}px - ${theme.spacing(WORKSPACE_PADDING * 2)})`;

export const fitColumnsToRachelWidth = (
  columns: number,
  dockedLayout: RachelDockedLayout | null,
): number => {
  if (!dockedLayout) {
    return columns;
  }

  const contentWidthAtMinimum = dockedLayout.groupWidth - RACHEL_PANEL_WIDTH;

  if (contentWidthAtMinimum <= 0) {
    return columns;
  }

  const contentWidth = dockedLayout.groupWidth - dockedLayout.width;
  const fittingColumns = Math.floor(
    (columns * contentWidth) / (contentWidthAtMinimum * CARD_SHRINK_TOLERANCE),
  );

  return Math.min(columns, Math.max(1, fittingColumns));
};
